export default __webpack_public_path__ + "static/media/imagem.e29333ea.png";